// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__24IxQ","label":"CategoryService_label__Tfy1i","location":"CategoryService_location__3kKNE"};